import { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../utils/api';

const useSubscriptionCheck = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkSubscription = async () => {
      const token = localStorage.getItem('token');
      if (!token || !user) {
        console.log('No token or user found, skipping subscription check.');
        return;
      }

      try {
        const response = await axios.post(`${API_BASE_URL}/api/auth/verify-subscription`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log('✅ Subscription check successful:', response.data);
      } catch (err) {
        console.error('❌ Subscription check failed:', err);

        if (err.response?.status === 403) {
          await Swal.fire({
            icon: 'warning',
            title: 'Subscription Expired',
            html: 'Your subscription has expired. Please <b>subscribe</b> to continue using Sparks Scribe.',
            showCancelButton: true,
            confirmButtonText: 'Subscribe Now',
            cancelButtonText: 'Logout',
            confirmButtonColor: '#6C5DD3',
            cancelButtonColor: '#d33',
          }).then((result) => {
            if (result.isConfirmed) {
              window.open('https://www.sparkscribe.ai/', '_blank');
            }
          });
        } else if (err.response?.status === 401) {
          await Swal.fire({
            icon: 'error',
            title: 'Session Invalid',
            text: 'Please log in again.',
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Subscription Check Failed',
            text: 'An error occurred while checking your subscription.',
          });
        }

        logout();
        localStorage.removeItem('token');
        navigate('/login');
      }
    };

    checkSubscription();
  }, [user, logout, navigate]);
};

export default useSubscriptionCheck;
